import React, { useEffect, useRef } from 'react';
import { Circle, Transformer } from 'react-konva';
import FunctionalityElipsis from './Functionality/EllipsisFunctionality';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const Ellipsis = ({
    ellipsis,
    index,
    selectedShapeId,
    handleDragMove,
    handleShapeClick,
    currentStage,
    setStageProperties,
    setShapeRadius,
}) => {
    const { shapeRef, isSelected, handleDragMoveWithLimit, handleTransformEnd, trRef, MAX_RADIUS } =
        FunctionalityElipsis({
            useRef,
            ellipsis,
            selectedShapeId,
            useEffect,
            handleDragMove,
            setShapeRadius,
            setStageProperties,
            currentStage,
            index,
        });

    return (
        <>
            <Circle
                x={ellipsis.x}
                y={ellipsis.y}
                rotation={ellipsis.rotation}
                radius={ellipsis.radius}
                fill={ellipsis.fill}
                stroke={ellipsis.stroke}
                strokeWidth={ellipsis.strokeWidth}
                id={ellipsis.id}
                ref={shapeRef}
                draggable={isSelected}
                onDragMove={(e) => handleDragMoveWithLimit(e, index)}
                onClick={() => handleShapeClick(ellipsis.id, 'ellipsis')}
                onTap={() => handleShapeClick(ellipsis.id, 'ellipsis')}
                onTransformEnd={handleTransformEnd}
            />
            {isSelected && (
                <Transformer
                    ref={trRef}
                    rotateEnabled={true}
                    boundBoxFunc={(oldBox, newBox) => {
                        if (newBox.width > MAX_RADIUS || newBox.height > MAX_RADIUS) {
                            return oldBox;
                        }
                        return newBox;
                    }}
                />
            )}
        </>
    );
};

export default Ellipsis;
